import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=5cd07ba5"
import script from "./InputLabel.vue?vue&type=script&lang=js"
export * from "./InputLabel.vue?vue&type=script&lang=js"
import style0 from "./InputLabel.vue?vue&type=style&index=0&id=5cd07ba5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports